<template>
  <div>
    <div class="m_secondBox">
      <div class="m_second_top">
        <span @click="goBack"></span>
        <h1>重大疾病保险</h1>
      </div>
      <div class="m_second_tab">
        <ul>
          <li
            @click="getNavChecked(item,index)"
            v-for="(item,index) in navList"
            :key="index"
            :class="{on:isNavChecked == index}"
          >{{item.name}}</li>
        </ul>
      </div>
    </div>
    <div id="main">
      <div class="main clearfix">
        <div class="mainconn mainConn1">
          <div class="mainLTab fl">
            <ul>
              <li
                @click="getBotNavChecked(item,index)"
                v-for="(item,index) in navBotList"
                :key="index"
                :class="{on:isBotNavChecked == index}"
              >{{item}}</li>
            </ul>
            <div class="mBlock">
              <span class="mBlockSpan" @click="openPicker()">{{value2}}</span>
              <mt-datetime-picker
                ref="picker"
                v-model="pickerVisible"
                type="date"
                year-format="{value} 年"
                month-format="{value} 月"
                :startDate="new Date(startTime)"
                :endDate="new Date(endTime)"
                @confirm="handleConfirm"
              ></mt-datetime-picker>
            </div>
          </div>
          <div class="mainRConn fl">
            <div class="mainRConnBox mainRConn1">
              <ul>
                <li
                  @click="gotoDetail(item.productNo,item.orgName)"
                  v-for="(item,index) in monthList"
                  :key="index"
                >
                  <div class="bxcpLOGO fl">
                    <img :src="item.logo_url" />
                  </div>
                  <div class="bxcpListConn fl">
                    <p class="bxcpName">{{item.name}}</p>
                    <p class="companyName">{{item.orgName}}</p>
                  </div>
                  <div class="bxcpStar">
                    <img
                      :src="'http://www.cfbond.com/static/images/sybx_star('+item.grade.length+').png'"
                    />
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footCom></footCom>
  </div>
</template>

<script>
import footCom from "../../components/footer/footer";
export default {
  components: { footCom },
  data() {
    return {
      monthList: [],
      navList: [
        { name: "重疾终身含身故", value: 0 },
        { name: "重疾终身无身故", value: 1 },
        { name: "重疾定期", value: 2 }
      ],
      navBotList: ["综合榜", "价格榜"],
      isNavChecked: 0,
      isBotNavChecked: 0,
      params: {
        insurance_type: "重疾终身含身故",
        rank_type: "综合榜",
        ym: ""
      },
      pickerVisible: "",
      startTime: "2018-09",
      endTime: "",
      value2: "",
      pickerOptions: {
        disabledDate: time => {
          return (
            time.getTime() < new Date(this.startTime) ||
            time.getTime() > new Date(this.endTime)
          );
        }
      }
    };
  },
  created() {
    // this.getMonthList();
    this.endTime = this.getEndTime();
    this.value2 = this.getEndTime();
    this.pickerVisible = new Date(this.getEndTime());
    this.params.ym = this.value2.slice(2).replace("-", "");
  },
  methods: {
    getNavChecked(item, index) {
      this.isNavChecked = index;
      this.params.insurance_type = item.name;
    },
    getBotNavChecked(item, index) {
      this.isBotNavChecked = index;
      this.params.rank_type = item;
    },
    getMonthList() {
      this.axios
        .get("App.insurance_list_ym.action", {
          params: this.params
        })
        .then(result => {
          this.monthList = result.data.data;
        });
    },
    goBack() {
      this.$router.go(-1);
    },
    openPicker() {
      this.$refs.picker.open();
      let a = document.getElementsByClassName("picker-slot");
      for (let i = 0; a && i < a.length; i++) {
        if (i == 2) {
          a[i].style.display = "none";
        }
      }
    },
    // 格式化获取的时间
    formatDate(date) {
      const y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      // let d = date.getDate();
      // d = d < 10 ? "0" + d : d;
      return y + "-" + m;
    },
    getEndTime() {
      let date = new Date();
      let y = date.getFullYear();
      let m = date.getMonth();
      m = m < 10 ? "0" + m : m;
      if (m == 0) {
        y = y - 1;
        m = 12;
      }
      return y + "-" + m;
    },
    //点击确定按钮之后
    handleConfirm() {
      // 输出格式化后的时间
      this.value2 = this.formatDate(this.$refs.picker.value);
    },
    //查看详情页
    gotoDetail(num, name) {
      this.$router.push({
        name: "detail",
        query: {
          product_no: num,
          rank_type: this.params.rank_type,
          company_name: name,
          ym: this.params.ym
        }
      });
    }
  },
  watch: {
    value2: {
      handler(newVal, oldVal) {
        this.params.ym =
          this.value2 != null
            ? this.value2.slice(2).replace("-", "")
            : this.endTime.slice(2).replace("-", "");
      }
    },
    params: {
      deep: true,
      handler(newVal, oldVal) {
        this.getMonthList();
      }
    }
  }
};
</script>

<style scoped>
.m_second_top {
  height: 44px;
  line-height: 44px;
  background: #ffa33b;
  color: #fff;
  text-align: center;
  position: relative;
  margin-bottom: 1px;
}
.m_second_top h1 {
  font-size: 20px;
}
.m_second_top span {
  position: absolute;
  left: 35px;
  top: 12px;
  display: block;
  width: 12px;
  height: 21px;
  background: url(../../images/bxcp_back.png) no-repeat;
  background-size: 100% 100%;
}
.m_second_tab ul {
  background: #fff;
}
.m_second_tab ul li {
  float: left;
  width: 33.33%;
  height: 38px;
  line-height: 38px;
  background: #fff;
  text-align: center;
  font-size: 15px;
}
.m_second_tab ul li.on {
  border-bottom: 2px solid #ffa33b;
}
.mBlock {
  display: block;
  position: absolute;
  right: 10px;
  top: 0;
}
.mBlockSpan {
  display: block;
  height: 30px;
  background: #fff;
  padding-left: 5px;
  border-radius: 8px;
  line-height: 30px;
  font-size: 14px;
  padding-right: 15px;
  position: relative;
}
.mBlockSpan::after {
  display: block;
  content: "";
  border: 4px solid transparent;
  border-top: 4px solid #bbb;
  position: absolute;
  right: 2px;
  top: 13px;
}
.main {
  width: 100%;
}
.mainLTab,
.mainRConn {
  float: none !important;
}
.main .mainLTab {
  height: 30px;
  margin: 8px 0;
  text-align: center;
  width: 100%;
  background: none;
  position: relative;
}
.main .mainLTab ul {
  width: 100%;
  text-align: center;
}
.main .mainLTab ul li {
  float: none;
  display: inline-block;
  width: 23.5%;
  margin-right: 0px;
  height: 30px;
  line-height: 30px;
  font-size: 15px;
  background: #fff;
}
.main .mainLTab ul li.on {
  background: #ff8109;
  color: #fff;
}
.main .mainLTab ul li:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.main .mainLTab ul li:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
.main .mainRConn,
.mainRConnBox {
  background: #fff;
  width: 100%;
}
.mainRTable {
  display: none;
}
.mainRConnBox ul {
  display: block;
}
.mainRConnBox ul li {
  height: 75px;
  padding: 15px 10px;
  margin-bottom: 2px;
  overflow: hidden;
}
.mainRConnBox ul li .bxcpLOGO {
  width: 23%;
  display: flex;
  align-items: center;
  justify-content: start;
  height: 100%;
}
.mainRConnBox ul li .bxcpLOGO img {
  width: 70%;
  vertical-align: middle;
}
.mainRConnBox ul li .bxcpListConn {
  width: 54%;
}
.mainRConnBox ul li .bxcpName {
  line-height: 20px;
  font-size: 15px;
  width: 100%;
  margin-bottom: 10px;
  height: 40px;
}
.mainRConnBox ul li .companyName {
  font-size: 14px;
  color: #797979;
}
.mainRConnBox ul li .bxcpStar {
  width: 23%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.mainRConnBox ul li .bxcpStar img {
  height: 20%;
}
#main {
  margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/page/home/homeMajor.vue